import { styled } from '@mui/material'

import TypographyWrapper from '../wrapper/TypographyWrapper'

export const LabelInputUserName = styled(TypographyWrapper)(({ theme }) => ({
  color: theme.palette.tertiary?.dark,
  fontFamily: 'Helvetica',
  fontSize: '25px',
  fontStyle: 'normal',
  fontWeight: '700',
  lineHeight: 'normal'
}))
